import { render, staticRenderFns } from "./JiaoTongSheshiFenbu.vue?vue&type=template&id=5702cdf8&scoped=true&"
import script from "./JiaoTongSheshiFenbu.vue?vue&type=script&lang=js&"
export * from "./JiaoTongSheshiFenbu.vue?vue&type=script&lang=js&"
import style0 from "./JiaoTongSheshiFenbu.vue?vue&type=style&index=0&id=5702cdf8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5702cdf8",
  null
  
)

export default component.exports